// import { Link } from "gatsby"
import React, { useState, useEffect, useRef } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import ArticleItem from "../../atoms/article-item/article-item"
import "./section-female-care.scss"
import Button from "../../../shared/components/atoms/button/button"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"

const SectionFemaleCare = ({ femaleCare, mobile, classNameCategory }) => {
  const sliderRef = useRef()
  const NextArrow = props => {
    const { onClick } = props
    return (
      <span className="f-slider-home-femalecare-next" onClick={onClick}>
        SIGUIENTE
      </span>
    )
  }
  const [femaleCareFilter, setfemaleCareFilter] = useState([])

  useEffect(() => {
    getRestrictedArticles()
  }, [])

  const getArticleaByAge = () => {
    return femaleCare
      .map(art =>
        art.segmentoDelArticulo.filter(
          a =>
            a.nombreEtiqueta === getAgeSegment(calculateAge()) ||
            a.nombreEtiqueta === "Anónimo"
        ).length > 0
          ? art
          : null
      )
      .filter(e => e !== null)
  }

  const getRestrictedArticles = () => {
    let tempItems = []
    getArticleaByAge().map(item => {
      // console.log((item.paisesDeRestriccionDelArticulo === null || !item.paisesDeRestriccionDelArticulo.includes(process.env.LOCALE.split('-')[1])))
      if (
        item.paisesDeRestriccionDelArticulo === null ||
        !item.paisesDeRestriccionDelArticulo.includes(
          process.env.LOCALE.split("-")[1]
        )
      ) {
        tempItems.push(item)
      }
    })
    setfemaleCareFilter(tempItems.slice(0, 9))
  }

  const calculateAge = () => {
    if (typeof window !== "undefined") {
      if (localStorage.getItem("USER_INFO") === null) {
        return 0
      } else {
        var today = new Date()
        var birthDate = new Date(
          JSON.parse(localStorage.getItem("USER_INFO")).birthdate
        )
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    } else {
      return 0
    }
  }

  const getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return "sara" //Sara
    } else if (age >= 18 && age <= 24) {
      return "carolina" //carolina
    } else {
      return "juliana" //juliana
    }
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: null,
  }

  const userInfoEncrypt= encryptUserInfo()
  const articleMagazinDatalayer = (article) => {
    pushDataLayerEvent({
      event: "Interacciones - Articulos",
      category: "magazin",
      sub_category: "Nuestro Mundo",
      action: "click",
      label: article.tituloArticulo,
      article_name: article.tituloArticulo,
      location: window.location.href,
      article_type: article.tipoDeArticulo,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const buttonRedirect = () => {
    window.location.href = siteUrl + "/entre-nosotras/cuidado-femenino/"
  }

  return (
    <div className="f-SectionFemaleCare">
      <div className="f-SectionFemaleCare-wrapper">
        <TitleTab
          className="f-TitleTab f-TitleTab-pink"
          title="Entre Nosotras"
        />
        <NextArrow
          onClick={() => {
            sliderRef.current.slickNext()
          }}
        />
        <Slider
          {...settings}
          ref={sliderRef}
          className={
            "f-carousel-female-care f-carousel-female-care-" + classNameCategory
          }
        >
          <div className="f-carousel-female-care-items">
            <ArticleItem
              item={femaleCareFilter}
              iStart={0}
              iEnd={1}
              news={false}
              dataLayer={articleMagazinDatalayer}
            />
          </div>
          <div className="f-carousel-female-care-items">
            <ArticleItem
              item={femaleCareFilter}
              iStart={2}
              iEnd={3}
              news={false}
              dataLayer={articleMagazinDatalayer}
            />
          </div>
          <div className="f-carousel-female-care-items">
            <ArticleItem
              item={femaleCareFilter}
              iStart={4}
              iEnd={5}
              news={false}
              dataLayer={articleMagazinDatalayer}
            />
          </div>
        </Slider>
        <div className="f-SectionFemaleCare-position-button">
          <Button
            className="new-dark-blue short"
            title={
              process.env.LOCALE === "es-PY"
                ? "Aprendé más acá"
                : "Aprende más aquí"
            }
            onClick={() => buttonRedirect()}
          />
        </div>
      </div>
    </div>
  )
}

export default SectionFemaleCare
